import React from 'react';

export const UserPage: React.FC = () => (
  <div style={{ padding: 32 }}>
    <h1>User</h1>
    <p>This is the User page.</p>
  </div>
); 